import { render } from "./BlogCard.vue?vue&type=template&id=64488630&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"

import "./BlogCard.vue?vue&type=style&index=0&id=64488630&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64488630"]])

export default __exports__